<template>
  <a-card :bordered="false">
    <div>
      <a-button type="primary" @click="addAccount">新增账号</a-button>
    </div>
    <custom-page-table
      style="margin-top:16px;"
      ref="table"
      :queryParams="queryParams"
      :columns="columns"
      base-key="serviceUrl"
      query-path="zwy/getZwyDistributorAccountList"
    >
      <span slot="action" slot-scope="rowItem">
        <a @click="editAccount(rowItem.record.distributorId)">编辑</a>
        <a-popconfirm
          v-if="rowItem.record.distributorStatus == 1"
          title="是否禁用？"
          @confirm="onUpdate(rowItem.record, 0)"
        >
          <a style="color:red;margin-left:20px;">禁用</a>
        </a-popconfirm>

        <a style="margin-left:20px;" v-else @click="onUpdate(rowItem.record, 1)">启用</a>
        <a style="margin-left:20px;" @click="onSynchronous(rowItem.record)">手动同步</a>
        <a style="margin-left:20px;" @click="ruleProSync(rowItem.record)">同步规则</a>
      </span>
    </custom-page-table>
    <a-modal
      :title="(distributorId ? '编辑' : '新增') + '账号'"
      :width="700"
      :footer="null"
      :visible="visible"
      @cancel="handleCancel"
    >
      <a-form-model
        :rules="rules"
        ref="formData"
        :model="formData"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item prop="distributorName" label="供应商名称">
          <a-input v-model.trim="formData.distributorName" placeholder="仅用于区分标识数据来源，6个字内"
                   :maxLength="6"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="distributorDomain" label="分销域名">
          <a-input v-model.trim="formData.distributorDomain" placeholder="请输入分销域名"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="distributorCustId" label="分销商帐号(custId)">
          <a-input v-model.trim="formData.distributorCustId" placeholder="请输入分销商帐号"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="distributorAppKey" label="分销商验证(apikey)">
          <a-input v-model.trim="formData.distributorAppKey" placeholder="请输入分销商验证"></a-input>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 5 }">
          <a-button type="primary" @click="onSave">提交</a-button>
          <a-button style="margin-left:20px;" @click="handleCancel">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal
      title="批量同步"
      :width="800"
      :footer="null"
      :visible="manualVisible"
      @cancel="handleManualCancel"
    >
      <a-form-model
        ref="form"
        :model="form"
        :rules="syncRules"
        :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="同步规则" required>
          <a-radio-group v-model="form.ruleType" @change="ruleTypeChange">
            <a-radio :value="1">全部同步</a-radio>
            <a-radio :value="2">仅同步商品信息</a-radio>
            <a-radio :value="3">指定商品同步</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item prop="productIds" label="自我游商品ID：" v-if="form.ruleType == 3">
          <a-textarea
            style="width:430px;"
            v-model="form.productIds"
            :rows="6"
            placeholder="请输入自我游商品ID，一行一个，最多20个"
          ></a-textarea>
        </a-form-model-item>
        <a-form-model-item prop="number" v-else label="同步数量">
          <a-input
            style="width:430px;"
            v-model="form.number"
            auto-complete="off"
            placeholder="请输入同步数量"
          ></a-input>
        </a-form-model-item>
      </a-form-model>
      <div style="position:relative;left:80%">
        <a-button type="primary" v-if="isClick" @click="clickProHigh()">确 定</a-button>
        <a-button type="info" v-else disabled>确定</a-button>
        <a-button style="margin-left: 20px;" @click="manualVisible = false">取 消</a-button>
      </div>
    </a-modal>
    <a-modal
      title="价格规则"
      :width="800"
      :footer="null"
      :visible="ruleVisible"
      @cancel="handleRuleCancel"
    >
      <a-form-model
        :rules="priceRules"
        ref="ruleForm"
        :model="ruleForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <p>提示：结算价格，指自我游给分销商的分销价格；零售价，指自我游显示的抢购价格；</p>
        <a-form-model-item label="本系统价格">自我游价格</a-form-model-item>
        <a-form-model-item label="建议销售价">零售价</a-form-model-item>
        <a-form-model-item label="同行价" prop="distributorAuditPriceRate">
          <span>结算价格 + ( 零售价 - 结算价格 ) *</span>
          <a-input
            class="input-width"
            placeholder="请输入内容"
            v-model="ruleForm.distributorAuditPriceRate"
            :maxLength="3"
          ></a-input>
          <span>%</span>
        </a-form-model-item>
        <a-form-model-item label="佣金" prop="distributorCommissionRate">
          <span>( 零售价 - 结算价格 ) *</span>
          <a-input
            class="input-width"
            placeholder="请输入内容"
            v-model="ruleForm.distributorCommissionRate"
            :maxLength="3"
          ></a-input>
          <span>%</span>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 12, offset: 5 }">市场价 = 市场价格</a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 12, offset: 5 }">采购价 = 结算价格</a-form-model-item>
        <h4>同步设置</h4>
        <a-form-model-item label="自动同步">
          <a-radio-group v-model="ruleForm.distributorIsAutoSync">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="0">否</a-radio>
          </a-radio-group>
          <span>*开启后每日0点-5点自动同步一次</span>
        </a-form-model-item>
        <a-form-model-item label="下单方式">
          <a-radio-group v-model="ruleForm.distributorIsOrderAutoSync">
            <a-radio :value="1">自动下单</a-radio>
            <a-radio :value="0">手动下单</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 12, offset: 5 }">
          <a-button type="primary" @click="submitFormYo('ruleForm')">确 定</a-button>
          <a-button style="margin-left:20px;" @click="ruleVisible = false">取 消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'AssociatedAccount',
  data() {
    return {
      columns: [
        {
          title: '供应商名称',
          dataIndex: 'distributorName'
        },
        {
          title: '分销域名',
          dataIndex: 'distributorDomain'
        },
        {
          title: '分销商帐号(custId)',
          dataIndex: 'distributorCustId'
        },
        {
          title: '分销商验证(apikey)',
          dataIndex: 'distributorAppKey'
        },
        {
          title: '状态',
          dataIndex: 'distributorStatusStr',
          width: '60px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '260px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      queryParams: {
        distributorMerchantId: this.$store.getters.userInfo.merchantId,
        distributorPlatformId: this.getPlatformConfig().platformId
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      visible: false,
      manualVisible: false,
      ruleVisible: false,
      distributorId: '',
      labelCol: { span: 5 },
      wrapperCol: { span: 17 },
      form: {
        distributorId: 0,
        number: '', // 同步数量
        ruleType: 1, //全量同步，2，同步信息，3，同步价格
        productIds: ''
      },
      formData: {
        distributorAppKey: '', // 分销商appkey
        distributorCustId: '', //分销商custid
        distributorDomain: '', //分销商域名
        distributorId: '',
        distributorMerchantId: this.$store.getters.userInfo.merchantId, //分销商对应供应商ID ,
        distributorPlatformId: this.getPlatformConfig().platformId,
        distributorStatus: '',
        distributorStatusStr: '',
        distributorName: ''
      },
      ruleForm: {
        distributorAuditPriceRate: '', //同行价增长率（%）,
        distributorCommissionRate: '', //佣金增长率（%） ,
        distributorId: '', // ID ,
        distributorIsAutoSync: 1, // 是否自动同步（1，是，0，否）
        distributorIsOrderAutoSync: 1 // 订单是否自动同步（1，是，0，否）
      },
      rules: {
        distributorName: { required: true, message: '请输入供应商名称', trigger: 'blur' },
        distributorDomain: { required: true, message: '请输入分销域名', trigger: 'blur' },
        distributorCustId: { required: true, message: '请输入分销商帐号', trigger: 'blur' },
        distributorAppKey: { required: true, message: '请输入分销商验证', trigger: 'blur' }
      },
      syncRules: {
        number: [
          { required: true, message: '请输入同步数量', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正确的同步数量', trigger: 'blur' }
        ],
        productIds: [
          { required: true, message: '请输入自我游商品ID，一行一个，最多20个', trigger: 'blur' }
        ]
      },
      priceRules: {
        distributorAuditPriceRate: [
          { required: true, message: '请输入同行价增长率', trigger: 'blur' },
          {
            pattern: /^(?:0|[1-9][0-9]?|100)$/,
            message: '请输入正确的同行价增长率',
            trigger: 'blur'
          }
        ],
        distributorCommissionRate: [
          { required: true, message: '请输入佣金增长率', trigger: 'blur' },
          {
            pattern: /^(?:0|[1-9][0-9]?|100)$/,
            message: '请输入正确的佣金增长率',
            trigger: 'blur'
          }
        ]
      },
      isClick: true
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ZwyConnection', title: '同步产品' },
      { name: 'DirectOrder', title: '订单直连' },
      { name: 'AssociatedAccount', title: '关联账号' }
    ])
  },
  methods: {
    ruleTypeChange() {
      this.form.number = ''
      this.form.productIds = ''
    },
    editAccount(id) {
      this.visible = true
      this.distributorId = id
      this.getDetail(id)
    },
    addAccount() {
      this.visible = true
      this.distributorId = ''
    },
    handleManualCancel() {
      this.manualVisible = false
    },
    handleCancel() {
      this.visible = false
    },
    handleRuleCancel() {
      this.ruleVisible = false
    },
    // 详情
    getDetail(id) {
      this.getHttpServices()
        .getServerApiService()
        .post('zwy/getZwyDistributorAccount/' + id)
        .then(res => {
          this.formData = res
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    // 保存
    onSave() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          this.onSaveData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    //新增保存自我游账号修改，新增
    onSaveData() {
      let params = {
        ...this.formData,
        categoryId: 8
      }
      this.getHttpServices()
        .getServerApiService()
        .post('zwy/saveOrUpdateZwyDistributorAccount', params)
        .then(res => {
          this.$message.success('操作成功')
          this.visible = false
          this.$refs.table.refresh(true)
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    clickProHigh() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.onSaveSyncData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    onSaveSyncData() {
      this.form.distributorId = this.distributorId
      this.isClick = false
      this.manualVisible = false
      let subForm = JSON.parse(JSON.stringify(this.form))
      this.getHttpServices()
        .getProService()
        .post('v2/zwy/rush', subForm)
        .then(res => {
          this.$message.success('操作成功')
          this.form.ruleType = 1
          this.form.number = ''
          this.form.productIds = ''
          this.isClick = true
        })
        .catch(err => {
          this.isClick = true
          this.$message.error(err.msg)
        })
    },
    // 禁用、启用
    onUpdate(item, status) {
      if (status == 1) {
        this.updateStatus(item, status)
      } else {
        this.updateStatus(item, status)
      }
    },
    //自我游禁用、启用接口
    updateStatus(item, status) {
      this.getHttpServices()
        .getServerApiService()
        .post('zwy/updateZwyDistributorAccountStatus/' + item.distributorId + '/' + status)
        .then(res => {
          this.$message.success('操作成功')
          this.$refs.table.refresh(true)
        })
        .catch(err => {
          this.$message.error('操作失败')
        })
    },
    // 手动同步
    onSynchronous(item) {
      this.distributorId = item.distributorId
      this.manualVisible = true
      this.isClick = true

    },
    //同步规则弹窗
    ruleProSync(item) {
      this.ruleVisible = true
      this.getZwyAsyncData(item.distributorId)
    },
    getZwyAsyncData(id) {
      this.getHttpServices()
        .getServerApiService()
        .post('zwy/getZwyDistributorAccountSetting/' + id)
        .then(res => {
          this.ruleForm = res
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    //同步规则确定
    submitFormYo(formName) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.saveData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    //保存
    saveData() {
      this.getHttpServices()
        .getServerApiService()
        .post('zwy/updateZwyDistributorAccountSetting', this.ruleForm)
        .then(res => {
          this.$message.success('同步规则设置成功')
          this.ruleVisible = false
          this.$refs.table.refresh(true)
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    }
  }
}
</script>
<style scoped>
.input-width {
  display: inline-block;
  width: 100px;
}
</style>
